module.exports = __webpack_public_path__ + "img/import_labels.f749ea40.svg";